import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = {
  key: 1,
  class: "submit-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_circle_loader = _resolveComponent("circle-loader")!
  const _component_base_form_field = _resolveComponent("base-form-field")!
  const _component_next_button = _resolveComponent("next-button")!
  const _component_step = _resolveComponent("step")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    allowCloseBtn: true,
    onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close', true))),
    class: "xs-mobile-h95"
  }, {
    default: _withCtx(() => [
      (_ctx.loading || _ctx.gettingData)
        ? (_openBlock(), _createBlock(_component_circle_loader, { key: 0 }))
        : (_openBlock(), _createBlock(_component_step, {
            key: 1,
            ref: "stepRef"
          }, {
            header: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("Confirm School Information", -1)
            ]))]),
            actions: _withCtx(() => [
              _createVNode(_component_next_button, {
                loading: _ctx.loading || _ctx.savingChanges,
                disabled: _ctx.loading || _ctx.savingChanges,
                onClick: _ctx.goBackToPortal,
                text: "Save Changes"
              }, null, 8, ["loading", "disabled", "onClick"])
            ]),
            default: _withCtx(() => [
              (_ctx.showConfirmationQuestion === true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_base_form_field, {
                      modelValue: _ctx.schoolInfo.schoolUndecided,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.schoolInfo.schoolUndecided) = $event)),
                      schema: _ctx.schema.schoolUndecided,
                      options: _ctx.schoolPlanOptions,
                      class: "school"
                    }, null, 8, ["modelValue", "schema", "options"]),
                    (_ctx.schoolInfo.schoolUndecided)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_base_form_field, {
                              modelValue: _ctx.schoolInfo.graduationDateMonth,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schoolInfo.graduationDateMonth) = $event)),
                              schema: _ctx.schema.graduationDateMonth,
                              options: _ctx.months()
                            }, {
                              "default-option": _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode("Month", -1)
                              ]))]),
                              _: 1
                            }, 8, ["modelValue", "schema", "options"])
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_base_form_field, {
                              modelValue: _ctx.schoolInfo.graduationDateYear,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schoolInfo.graduationDateYear) = $event)),
                              schema: _ctx.schema.graduationDateYear,
                              options: _ctx.years(true)
                            }, {
                              "default-option": _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("Year", -1)
                              ]))]),
                              _: 1
                            }, 8, ["modelValue", "schema", "options"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_base_form_field, {
                      ref: "schoolSearchRef",
                      modelValue: _ctx.schoolInfo.school,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.schoolInfo.school) = $event)),
                        _ctx.handleSchoolSelection
                      ],
                      schema: _ctx.schema.school,
                      autocompleteOptions: _ctx.schools,
                      class: _normalizeClass({
                'is-invalid': _ctx.schoolInfo.school?.id === null && !_ctx.schema.valid,
              })
                    }, null, 8, ["modelValue", "schema", "autocompleteOptions", "onUpdate:modelValue", "class"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createVNode(_component_base_form_field, {
                      modelValue: _ctx.schoolInfo.academicTermId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.schoolInfo.academicTermId) = $event)),
                      modelModifiers: { number: true },
                      schema: _ctx.schema.academicTermId,
                      options: _ctx.academicTermOptions
                    }, null, 8, ["modelValue", "schema", "options"]), [
                      [_vShow, _ctx.showEnrollmentTerms]
                    ])
                  ])
                ]),
                (_ctx.schoolInfo.academicTermId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_base_form_field, {
                          modelValue: _ctx.schoolInfo.enrollmentStatusId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.schoolInfo.enrollmentStatusId) = $event)),
                          schema: _ctx.schema.enrollmentStatusId,
                          options: _ctx.enrollmentStatusOptions
                        }, null, 8, ["modelValue", "schema", "options"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_base_form_field, {
                      modelValue: _ctx.schoolInfo.graduationDateMonth,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.schoolInfo.graduationDateMonth) = $event)),
                      schema: _ctx.schema.graduationDateMonth,
                      options: _ctx.months()
                    }, {
                      "default-option": _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Month", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue", "schema", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_base_form_field, {
                      modelValue: _ctx.schoolInfo.graduationDateYear,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.schoolInfo.graduationDateYear) = $event)),
                      schema: _ctx.schema.graduationDateYear,
                      options: _ctx.years(true)
                    }, {
                      "default-option": _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("Year", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue", "schema", "options"])
                  ])
                ]),
                (_ctx.invalidEnrollmentTerm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("p", null, "Graduation Date must be after the selected Academic Period.", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, 
          (_ctx.showConfirmationQuestion === true && _ctx.schoolInfo.schoolUndecided === false) ||
          _ctx.showConfirmationQuestion === false
        ]
              ])
            ]),
            _: 1
          }, 512))
    ]),
    _: 1
  }))
}